import Link from 'next/link';
import { AnchorHTMLAttributes, MouseEventHandler } from 'react';

import { styles } from './PaginationButton.styles';

interface PaginationButtonProps
  extends AnchorHTMLAttributes<HTMLAnchorElement> {
  selected?: boolean;
  href: string;
  disabled?: boolean;
  disabledNavigation?: boolean;
}

export function PaginationButton({
  children,
  selected,
  disabled,
  href,
  disabledNavigation,
  onClick,
  ...props
}: PaginationButtonProps) {
  const slots = styles();

  const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    if (disabledNavigation) {
      event.preventDefault();
    }

    onClick?.(event);
  };

  return (
    <Link
      className={slots.base({ selected, disabled })}
      href={href}
      onClick={handleClick}
      {...props}
    >
      {children}
    </Link>
  );
}
